import { Injectable } from '@angular/core';
import { of, BehaviorSubject, Observable } from 'rxjs';
import { VentaService } from './venta.service';
import { Router } from '@angular/router';
import { MotivosService } from './motivos.service';
import { RecintosService } from './recintos.service';
import { ConfigurationService } from '../../../core/conf/configuration.service';
import { AppConfiguration } from '../../../app.configuration';
import { ProcedenciaService } from './procedencia.service';
import { Pasos } from '../models/breadcrumbs';
import { TpvPathResult } from 'src/app/core/conf/modulo.model';

@Injectable({
  providedIn: 'root'
})
export class StepperNavigationService {
  continuarVenta = new BehaviorSubject(undefined);
  private datosTPVPathSubject: BehaviorSubject<TpvPathResult>;
  public datosTPVPath: Observable<TpvPathResult>;

  horarios = {
    url: 'horarios',
    nombre: 'HORARIOS',
    visible: false,
    activado: true
  };

  procedencia = {
    url: 'procedencia',
    nombre: 'PROCEDENCIA',
    visible: false,
    activado: false
  }

  sessiones = {
    url: 'seleccion-sesiones',
    nombre: 'SESIONES',
    visible: false,
    activado: true
  }

  butacas = {
    url: 'seleccion-butaca',
    nombre: 'SELECCION_LOCALIDAD',
    visible: false,
    activado: true
  }

  pasosEntradas = {
    url: 'entradas',
    nombre: 'ENTRADAS',
    visible: true,
    activado: true,
  }

  pasosTienda = {
    url: 'tienda',
    nombre: 'TIENDA',
    visible: true,
    activado: true,
  }

  pasosRestauracion = {
    url: 'restauracion',
    nombre: 'RESTAURACIÓN',
    visible: true,
    activado: true,
  }

  pasosAmigosThyssen = {
    url: 'amigos-thyssen',
    nombre: 'AMIGOS_THYSSEN',
    visible: true,
    activado: true,
  }

  pasosGestionar = {
    url: 'gestionar-pausadas',
    nombre: 'GESTIONAR',
    visible: false,
    activado: false,
  }

  pasosActividades = {
    url: 'actividades',
    nombre: 'AUDITORIO',
    visible: true,
    activado: true,
  }

  pasosPago = {
    url: 'pago',
    nombre: 'PAGO',
    visible: false,
    activado: true,
  }

  pasosData = [
    {
      url: 'entradas',
      nombre: 'ENTRADAS',
      visible: true,
      activado: true,
      pasos: [this.pasosEntradas, this.horarios, this.procedencia, this.pasosPago]
    },
    {
      url: 'tienda',
      nombre: 'TIENDA',
      visible: true,
      activado: true,
      pasos: [this.pasosTienda, this.procedencia, this.pasosPago]
    },
    {
      url: 'restauracion',
      nombre: 'RESTAURACIÓN',
      visible: true,
      activado: true,
      pasos: [this.pasosRestauracion, this.procedencia, this.pasosPago]
    },
    {
      url: 'amigos-thyssen',
      nombre: 'AMIGOS_THYSSEN',
      visible: true,
      activado: true,
      pasos: [this.pasosAmigosThyssen, this.procedencia, this.pasosPago]
    },
    {
      url: 'gestionar-pausadas',
      nombre: 'GESTIONAR',
      visible: false,
      activado: false,
      pasos: []
    },
    {
      url: 'actividades',
      nombre: 'AUDITORIO',
      visible: true,
      activado: true,
      pasos: [this.pasosActividades, this.sessiones, this.butacas, this.procedencia, this.pasosPago]
    },
  ];

  pasos = this.pasosData[0].pasos;

  private nextRoute: Pasos;
  //private recintos = [];
  puedeIrAPago = new BehaviorSubject(true);

  constructor(
    private router: Router,
    private venta: VentaService,
    private motivosService: MotivosService,
    private recintosService: RecintosService,
    public procedenciasService: ProcedenciaService,
    private configuration: ConfigurationService,
    private appConfig: AppConfiguration,
  ) {
    this.datosTPVPathSubject = new BehaviorSubject(undefined);
    this.datosTPVPath = this.datosTPVPathSubject.asObservable();
  }

  get getPasos() {
    return this.pasos;
  }

  getSteps() {
    return of(this.pasos);
  }

  setDatosTPVPathValue(datosTPVPath: TpvPathResult) {
    this.datosTPVPathSubject.next(datosTPVPath);
    this.procedencia = {
      url: 'procedencia',
      nombre: 'PROCEDENCIA',
      visible: false,
      activado: datosTPVPath 
      && datosTPVPath.TipoProcedencia 
      && (datosTPVPath.TipoProcedencia !== "0" && datosTPVPath.TipoProcedencia !== "") ? true : false
    }

    this.pasosData = this.pasosData.map(pasos => ({ ...pasos, pasos: pasos.pasos.map(paso => ({ ...paso, activado: paso.url === 'procedencia' ? this.procedencia.activado : paso.activado })) }))
    this.pasos = this.pasos.map(paso => ({ ...paso, activado: paso.url === 'procedencia' ? this.procedencia.activado : paso.activado }));
  }

  siguientePaso(url: string) {
    const pasos = this.pasos.filter(paso => paso.activado === true);
    return pasos[pasos.findIndex(paso => paso.url === url) + 1];
  }

  anteriorPaso(url: string) {
    const pasos = this.pasos.filter(paso => paso.activado === true);
    return pasos[pasos.findIndex(paso => paso.url === url) - 1];
  }

  hacerVisible(url: string) {
    this.pasos[this.pasos.findIndex(paso => paso.url === url)].visible = true;
  }

  resetearPasos() {
    this.pasos.forEach((paso, i) => {
      if (i !== 0) {
        paso.visible = false;
      }
    });
  }

  bloquearNavegacionPorPago() {
    this.pasos.forEach(paso => {
      if (paso.url !== 'pago') {
        paso.activado = false;
      }
    });
  }

  desbloquearNavegacionPorPago() {
    this.pasos.forEach(paso => {
      if (paso.url === 'procedencia') {
        paso.activado = this.datosTPVPathSubject.value
          && this.datosTPVPathSubject.value
          && (this.datosTPVPathSubject.value.TipoProcedencia !== "0" && this.datosTPVPathSubject.value.TipoProcedencia !== "") ? true : false
      } else {
        paso.activado = true;
      }

    });
  }

  next() {
    const url = this.getUrlVentaSlice();
    (url !== 'procedencia') && this.setHorarios();
    this.nextRoute = this.siguientePaso(url);

    //WOIT debriamos saltarnos los pasos no activos
    if (!this.nextRoute) {
      return;
    }
    switch (url) {
      case 'entradas':
        if (this.venta.carritoValue.entradas.length === 0) {
          return;
        }
        this.navigateToNextRoute();
        break;

      case 'horarios':
        // let puedeIrAPago = true;
        // this.recintosService.recintosValue.forEach(m => {
        //   const seHaElegidoRecinto = this.venta.carritoValue.horarios.find(
        //     h => h.recinto.Recinto === m.Recinto
        //   );
        //   if (m.obligatorio && !seHaElegidoRecinto) {
        //     puedeIrAPago = false;
        //   }
        // }); 
        
        // if (puedeIrAPago) {
        //   this.navigateToNextRoute();
        // }

        // manieva
        // exporte la funcion para poder validar esto desde el service
        // me sirve para poder entender desde el pago de espectaculos si puedo continuar
        const horariosCompletos = this.venta.esEntradaConHorariosCompletos();
        if(horariosCompletos)
          this.navigateToNextRoute();

        break;

      case 'amigos-thyssen':
        // Para amigos-thyssen, siempre redirigir independientemente de si hay entradas
        // Usar la misma lógica que cancelarVenta()
        const compraInicio = this.appConfig.getConfig('COMPRAINICIO');
        
        if (compraInicio) {
          this.router.navigate([compraInicio]);
        } else {
          // No establecer continuarVenta en true para amigos-thyssen
          this.router.navigate(['']);
        }
        break;

      case 'procedencia':
        //comprobamos si se han seleccionado todas las procedencias antes de saltar al siguiente.
        //necesitaamos un procedencias service similar al de recintos
        setTimeout(() => {
          let continuamos = this.procedenciasService.procedenciasCompletas();
          if (continuamos){ this.navigateToNextRoute();}
        },500);
        break;

      default:
        this.navigateToNextRoute();
    }
  }

  getUrlVentaSlice() {
    const convertToArrUlr = this.router.url.split('/');
    const url = convertToArrUlr.length > 1 ? convertToArrUlr[convertToArrUlr.length -1] : convertToArrUlr[0];

    if (this.router.url === '/' || this.router.url === '/tienda' || this.router.url === '/restauracion' || this.router.url === '/amigos-thyssen' || this.router.url.includes('actividades')) {
      this.pasos = this.pasosData.filter(paso => {
        if (url === '' || url === '/') {
          return paso.url === 'entradas'
        }

        if (url.includes('actividades')) {
          return paso.url.includes('actividades')
        }
        
        return paso.url === url;
      })[0].pasos;
      
      return url === '' || url === '/' ? 'entradas' : url;  
    } 

    return this.router.url.split('/')[2];
  }

  navigateToNextRoute() {
    const relativeToPath = 'venta/' + this.nextRoute.url;
    this.router
      .navigate([relativeToPath], { state: { fromButton: true } })
      .then(success => {
        if (success) {
          this.hacerVisible(this.nextRoute.url);
          this.venta.carritoModificado = false;
          this.venta.setHayDescuento(false); //Yaribel 20210730  cliente Mapfre VSTS 8370
        }
      });
  }

  setMotivos() {
    const entradasMotivos = [];
    
    this.venta.carritoValue.entradas.forEach(e => {
      if (e.entrada.TipoProductoId === '1' && e.entrada.GrupoMotivoid !== '') {
        entradasMotivos.push({
          Entrada: e.entrada,
          GrupoMotivoId: e.entrada.GrupoMotivoid,
          cantidad: e.cantidad
        });
          //<< Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables                   
      // } else if (e.entrada.TipoProducto === '2') {   //
      } else if (e.entrada.TipoProducto === '2' && e.entrada.GrupoMotivoid !== '') {       
        for (let i = 0; i < e.entrada.PromocionEntradas.length; i++) {
                  // if (e.entrada.PromocionEntradas[i].GrupoMotivoId !== '') {
            entradasMotivos.push({
              Entrada: e.entrada,
              //GrupoMotivoId: e.entrada.PromocionEntradas[i].GrupoMotivoId,
              GrupoMotivoId:  e.entrada.GrupoMotivoid,
              cantidad:
                e.cantidad *
                parseInt(e.entrada.PromocionEntradas[i].NumeroEntradas, 10)
            });
            return;
          // }
        }
      }
    });
    // 
    this.pasos[this.pasos.findIndex(paso => paso.url === 'motivos')].activado =
      entradasMotivos.length === 0 ? false : true;
    this.pasos[this.pasos.findIndex(paso => paso.url === 'motivos')].visible =
      entradasMotivos.length === 0 ? false : true;
    this.venta.carritoValue.hayDescuentoMotivo =
      entradasMotivos.length === 0 ? false : true;
    this.motivosService.setMotivosValue(entradasMotivos);
  }

  setHorarios() {
    const misRecintos = this.generarRecintos();
    let isAuditorio = false;
    // this.venta.carritoValue.entradas.forEach(e => {
    //   if (e.entrada.hasOwnProperty('auditorio') && e.entrada.auditorio === true) {
    //     isAuditorio = true;
    //   }
    // });
    const recintosSeleccion = [];
    misRecintos.forEach((miRecinto: any) => {
      if (miRecinto.Activo === '1' && miRecinto.ControlaAforo === '1') {
        const esObligatorioSeleccionar =
          miRecinto.EsActividad === '0' ? true : false;
        recintosSeleccion.push({
          obligatorio: esObligatorioSeleccionar,
          ...miRecinto
        });
      }
    });
    const indexHorario = this.pasos.findIndex(paso => paso.url === 'horarios');
    if(this.venta.esEntradaCombinada() && indexHorario !== -1) {
      this.pasos[indexHorario].activado =
      recintosSeleccion.length !== 0 || isAuditorio ? true : false;
      this.pasos[indexHorario].visible =
      recintosSeleccion.length !== 0 || isAuditorio ? true : false;
    } else if (indexHorario !== -1) {
      this.pasos[indexHorario].activado =
      recintosSeleccion.length === 0 ? false : true;
      this.pasos[indexHorario].visible =
      recintosSeleccion.length === 0 ? false : true;
    }
    this.recintosService.setRecintosValue(recintosSeleccion);
  }
  setHorariosNew() {
   
    const recintos = this.generarRecintos()
      .filter(recinto => recinto.Activo === '1' && recinto.ControlaAforo === '1')
      .map(recinto => ({ obligatorio: (recinto.EsActividad === '0'), ...recinto }));
    
    // se activan los pasos
    const indexHorario = this.pasos.findIndex(paso => paso.url === 'horarios');
    this.pasos[indexHorario].activado = (recintos.length === 0);
    this.pasos[indexHorario].visible = (recintos.length === 0);

    this.recintosService.setRecintosValue(recintos);
 
  }

  generarRecintos() {
    const recintos = [];
    const trazasEntradas: any[] = [];
    this.venta.carritoValue.entradas.forEach(e => {
      const esEntradaAsociado = !!(e && e.entrada && e.entrada.desdeAsociado);
      const dniAbonadoPresente = !!(e && e.entrada && e.entrada.DNIAbonadosExt && e.entrada.DNIAbonadosExt !== '');
      const esEntradaAmigosThyssen = dniAbonadoPresente && !esEntradaAsociado;
      trazasEntradas.push({
        tipoEntradaId: e?.entrada?.TipoEntradaId,
        desdeAsociado: esEntradaAsociado,
        dniAbonadoPresente,
        esEntradaAmigosThyssen,
        noEditable: e?.entrada?.noEditable,
        recintosEnEntrada: Array.isArray(e?.entrada?.recintos) ? e.entrada.recintos.length : -1
      });
      if (e.entrada.recintos && e.entrada.recintos.length > 0) {
        if (
          (!('noEditable' in e.entrada) || e.entrada.noEditable !== true || e.entrada.noEditable === false) &&
          !esEntradaAmigosThyssen
        ) {
          e.entrada.recintos.forEach((r: any) => {
            recintos.push(r);
          });
        }
      }
    });
    const mapeoRecintoEntrada = recintos.map(r => ({
      idRecinto: r.Recinto,
      entrada: r.TipoEntrada
    }));

    const recintosConEntrada = recintos.map((r: any) => {
      r.entradas = mapeoRecintoEntrada
        .filter(re => re.idRecinto === r.Recinto)
        .map(rec => rec.entrada);
      return r;
    });
    const recintosUnicos = this.removeDuplicates(recintosConEntrada, 'Recinto');
    return recintosUnicos;
  }

  compruebaProcedencias()
  {
    this.pasos[this.pasos.findIndex(paso => paso.url === 'procedencia')].activado =
      this.datosTPVPathSubject.value
        && this.datosTPVPathSubject.value
        && (this.datosTPVPathSubject.value.TipoProcedencia !== "0" && this.datosTPVPathSubject.value.TipoProcedencia !== "") ? true : false
    //WOIT comprobacion tenemos datos
  }
  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  getCurrentPasoUrl() {
    const getPasoUrl = this.pasos[0].url
    const updatedUrl = getPasoUrl === 'entradas' ? '' : getPasoUrl;
    const url = updatedUrl === 'actividades' ? 'auditorio/actividades' : updatedUrl;

    return url;
  }

  eliminarHorarioDePasos() {
    this.pasosData = this.pasosData.map(pasosData => {
      const pasos = pasosData.pasos;
      if (pasosData.url !== 'entradas') {
        const indexDeHorarios = pasos.findIndex(paso => paso.url === 'horarios')
        indexDeHorarios !== -1 && pasos.splice(indexDeHorarios, 1);
      }
      
      return { ...pasosData, pasos: pasos}
    })
  }
}
